import { apiRequest } from '~/_v3/common/services/httpService';

export const getHealth = async () => {
	return apiRequest('/health', 'GET');
};
